import service from '@/utils/server';

//路线图上传
export const uploadUrl = process.env.BASE_URL + '/md/plantArea/uploadImage';

const modName='/md/plantArea/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const getBindPlantStorage = data => {
  return service({
    url: '/md/plantStorage/' + 'getBindPlantStorage',
    method: 'post',
    data
  });
};

export const addPlantArea = data => {
  return service({
    url: modName + 'addPlantArea',
    method: 'post',
    data
  });
};

export const updatePlantArea = data => {
  return service({
    url: modName + 'updatePlantArea',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    data
  });
};

export const preview = data =>{
  return service({
    url: '/common/web/image' + 'preview/'+data,
    method: 'post',
  });
}

export const updatePlantAreaDetail = data => {
  return service({
    url: modName + 'updatePlantAreaDetail',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/md/plantArea/api/index.js